<div class="login-container">
  <div class="login-register-content login-container-form">
    @if (isUpdating$ | async) {
      <cx-spinner class="overlay"></cx-spinner>
    }
    <form
      (ngSubmit)="onSubmit()"
      [formGroup]="form"
      [attr.method]="method"
      [attr.action]="action"
      #loginForm
    >
      <h2>{{'loginForm.loginIn' | cxTranslate}}</h2>
      <label>
        <span class="label-content">
          {{ 'loginForm.emailAddress.label' | cxTranslate }}
        </span>
        <input type="email"
          class="form-control"
          formControlName="userId"
          autocomplete="username"
        />
        <cx-form-errors [control]="form.get('userId')"></cx-form-errors>
      </label>

      <label class="label-password">
        <span class="label-content">{{ 'loginForm.password.label' | cxTranslate}}</span>
        <input [type]="showPassword ? 'text' : 'password'"
            class="form-control"
            formControlName="password"
            autocomplete="current-password"
        />
        @if (showPassword) {
          <app-custom-icons (click)="showPassword = !showPassword" [type]="iconTypes.EYE"></app-custom-icons>
        } @else {
          <app-custom-icons (click)="showPassword = !showPassword" [type]="iconTypes.EYE_SLASH"></app-custom-icons>
        }
        <cx-form-errors [control]="form.get('password')"></cx-form-errors>
      </label>

      @if(csrf) {
        <ng-container *cxFeature="'authorizationCodeFlowByDefault'">
          <input
            formControlName="csrf"
            type="hidden"
            [name]="csrf.parameterName"
          />
        </ng-container>
      }

      <button type="submit" class="btn btn-block btn-black" [disabled]="form.disabled">
        {{ 'loginForm.signIn' | cxTranslate }}
      </button>
      <div class="btn-reset-password-container">
        <a [routerLink]="{ cxRoute: 'forgotPassword' } | cxUrl" aria-controls="reset-password" class="reset-password">
          {{ 'loginForm.forgotPassword' | cxTranslate }}
        </a>
      </div>
      <div class="login-checkout-register">
        <div class="register-text">
          {{ 'loginForm.iWantToRegister' | cxTranslate }}
        </div>
        <a [routerLink]="{ cxRoute: 'register' } | cxUrl" class="btn btn-block btn-white register-link">
          {{ 'loginForm.iWantToRegister2' | cxTranslate }}
        </a>
      </div>
    </form>
  </div>
</div>
